import Base from "./base";

export default class Auth extends Base{
    BASE_PATH = "/auth"

    auth(){
       return this.runGet("/default")
    }
}